<div class="text-center mb-3">
  <a [ngClass]="{'link-disabled': selectedMonday() <= currentWeekMonday}"
     (click)="selectPreviousWeek()" class="btn btn-primary btn-sm pointer text-white me-3"><</a>
  @if (selectedMonday() !== latestMondayInner()) {
    <div class="d-inline">
      {{ selectedMonday() | dateParse | dateFormat: dateFormat }} -
      {{ selectedSunday() | dateParse | dateFormat: dateFormat }}
    </div>
  }
  @if (selectedMonday() === latestMondayInner()) {
    <div class="d-inline">
      From {{ selectedMonday() | dateParse | dateFormat: dateFormat }}
    </div>
  }
  <a [ngClass]="{'link-disabled': selectedMonday() >= latestMondayInner()}"
     (click)="selectNextWeek()" class="btn btn-primary btn-sm pointer text-white ms-3">></a>
</div>